module.exports = __webpack_public_path__ + "img/1cHII-mVB09Ygbvt7drjBlb1PIh7nasxv.b24c5cbd.png";